import React from 'react';
import { ColumnSection, SectionColumnWidth } from '../types';
import { ComponentElement } from '../components';
import { SectionProps } from './types';

// grid grid-flow-row auto-rows-max grid-cols-1 md:grid-cols-3 lg:grid-cols-9 xl:grid-cols-12
const cssMap: Record<SectionColumnWidth, string> = {
  full: 'full-column w-full', // 'col-span-1 md:col-span-4 lg:col-span-8 xl:col-span-12',
  half: 'half-column w-full lg:w-1/2 self-stretch',
  '1/3': 'third-column w-full lg:w-1/3',
  '2/3': 'two-third-column w-full lg:w-2/3',
  '1/4': 'quarter-column w-full lg:w-1/4',
  '3/4': 'three-quarter-column w-full lg:w-3/4',
};

function ColumnSectionElement({ section }: SectionProps) {
  const { columns, type } = section as ColumnSection;
  return (
    <div className="core-page-column-section w-full max-w-full flex flex-column lg:flex-row gap-2 md:gap-3 lg:gap-4 xl:gap-6">
      {columns.map((col, idx) => (
        <div className={cssMap[col.width]} key={`${type}_${col.component.name}_${idx}`}>
          <ComponentElement component={col.component} />
        </div>
      ))}
    </div>
  );
}

export { ColumnSectionElement };
